import _ from 'lodash';
import {all} from 'redux-saga/effects';

import {createFetchSagaLatest, createPostSagaLatest} from 'utils/sagas';

import {
  fetchArrivals,
  fetchCheckedInTodayArrivals,
  fetchDepartures,
  fetchCheckedOutTodayDepartures,
  roomInspectionPass,
  roomInspectionRemove,
  fetchMemberCheckInInfo,
  fetchMemberCheckOutInfo,
  fetchRoomMoves,
  fetchPendingRenewals,
  completeRoomMove,
  undoCompleteRoomMove,
  renewBooking,
  undoRenewBooking,
  fetchCompletedRenewals,
  fetchRoomMove,
  giveAccessToRoom,
  undoGiveAccessToRoom,
  vacateRoom,
  undoVacateRoom,
  fetchPaymentSummary,
  fetchRenewBookingInfo,
  fetchCompletedRoomMoves
} from 'sdk/frontDesk';
import {
  checkInTenants,
  checkOutTenants,
  undoCheckInTenants,
  undoCheckOutTenants
} from 'sdk/tenancy';

import {
  fetchArrivals as fetchArrivalsAction,
  fetchCheckedInTodayArrivals as fetchCheckedInTodayArrivalsAction,
  fetchDepartures as fetchDeparturesAction,
  fetchCheckedOutTodayDepartures as fetchCheckedOutTodayDeparturesAction,
  fetchMemberCheckInInfo as fetchMemberCheckInInfoAction,
  fetchMemberCheckOutInfo as fetchMemberCheckOutInfoAction,
  fetchCompletedRoomMoves as fetchCompletedRoomMovesAction,
  fetchRoomMoves as fetchRoomMovesAction,
  fetchPendingRenewals as fetchPendingRenewalsAction,
  fetchCompletedRenewals as fetchCompletedRenewalsAction,
  fetchRoomMove as fetchRoomMoveAction,
  checkInTenants as checkInTenantsAction,
  checkOutTenants as checkOutTenantsAction,
  undoCheckInTenants as undoCheckInTenantsAction,
  undoCheckOutTenants as undoCheckOutTenantsAction,
  roomInspectionPass as roomInspectionPassAction,
  roomInspectionRemove as roomInspectionRemoveAction,
  completeRoomMove as completeRoomMoveAction,
  undoCompleteRoomMove as undoCompleteRoomMoveAction,
  renewBooking as renewBookingAction,
  undoRenewBooking as undoRenewBookingAction,
  giveAccessToRoom as giveAccessToRoomAction,
  undoGiveAccessToRoom as undoGiveAccessToRoomAction,
  vacateRoom as vacateRoomAction,
  undoVacateRoom as undoVacateRoomAction,
  fetchPaymentSummary as fetchPaymentSummaryAction,
  fetchRenewBookingInfo as fetchRenewBookingInfoAction
} from './';

function* frontDeskSaga() {
  yield all([
    createFetchSagaLatest(fetchRoomMovesAction, fetchRoomMoves),
    createFetchSagaLatest(
      fetchCompletedRoomMovesAction,
      fetchCompletedRoomMoves
    ),
    createFetchSagaLatest(fetchPendingRenewalsAction, fetchPendingRenewals),
    createFetchSagaLatest(fetchArrivalsAction, fetchArrivals),
    createFetchSagaLatest(
      fetchCheckedInTodayArrivalsAction,
      fetchCheckedInTodayArrivals
    ),
    createFetchSagaLatest(fetchDeparturesAction, fetchDepartures),
    createFetchSagaLatest(
      fetchCheckedOutTodayDeparturesAction,
      fetchCheckedOutTodayDepartures
    ),
    createFetchSagaLatest(fetchCompletedRenewalsAction, fetchCompletedRenewals),
    createFetchSagaLatest(fetchRoomMoveAction, fetchRoomMove),
    createFetchSagaLatest(fetchMemberCheckInInfoAction, fetchMemberCheckInInfo),
    createFetchSagaLatest(
      fetchMemberCheckOutInfoAction,
      fetchMemberCheckOutInfo
    ),
    createFetchSagaLatest(fetchPaymentSummaryAction, fetchPaymentSummary),
    createFetchSagaLatest(fetchRenewBookingInfoAction, fetchRenewBookingInfo),

    createPostSagaLatest(checkInTenantsAction, checkInTenants),
    createPostSagaLatest(undoCheckInTenantsAction, undoCheckInTenants),
    createPostSagaLatest(checkOutTenantsAction, checkOutTenants),
    createPostSagaLatest(undoCheckOutTenantsAction, undoCheckOutTenants),
    createPostSagaLatest(roomInspectionPassAction, roomInspectionPass),
    createPostSagaLatest(roomInspectionRemoveAction, roomInspectionRemove),
    createPostSagaLatest(completeRoomMoveAction, completeRoomMove),
    createPostSagaLatest(undoCompleteRoomMoveAction, undoCompleteRoomMove),
    createPostSagaLatest(renewBookingAction, renewBooking),
    createPostSagaLatest(undoRenewBookingAction, undoRenewBooking),
    createPostSagaLatest(giveAccessToRoomAction, giveAccessToRoom),
    createPostSagaLatest(undoGiveAccessToRoomAction, undoGiveAccessToRoom),
    createPostSagaLatest(vacateRoomAction, vacateRoom),
    createPostSagaLatest(undoVacateRoomAction, undoVacateRoom)
  ]);
}

export default frontDeskSaga;
